export const photos = {
  pejnovic: require('./pejnovic.jpg'),
  klincic: require('./klincic.jpg')
}
